import { faMinus } from "@fortawesome/free-solid-svg-icons/faMinus"
import { faPlus } from "@fortawesome/free-solid-svg-icons/faPlus"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

export default function EmployeeFunnelPersonTypeSelector({ onAdd, onRemove, count, text, subText }) {
	return (
		<div className="mb-2 relative selectionEntry color-bg-default">
			<div className="flex flex-items-center fill selectionEntry color-fg-primary">
				<div className="flex-grow-1 of-hidden">
					<div className="ellipsis">
						<div className="semibold color-fg-primary">{text}</div>
						<div className="f4 color-fg-secondary">{subText}</div>
					</div>
				</div>

				<div className="flex flex-items-center flex-shrink-0 mr-3 ml-3">
					<>
						{count > 0 && (
							<div
								className="color-fg-primary flex flex-center circle border color-border-primary f4 selectorIcon"
								onClick={e => {
									e.stopPropagation()
									onRemove()
								}}
							>
								<FontAwesomeIcon icon={faMinus} />
							</div>
						)}
						<div className="f4 f-lg-3 mx-3 mx-lg-4 flex flex-center regular">{count}</div>
						<div
							className="color-fg-primary flex flex-center circle border color-border-primary f4 selectorIcon"
							onClick={e => {
								e.stopPropagation()
								onAdd()
							}}
						>
							<FontAwesomeIcon icon={faPlus} />
						</div>
					</>
				</div>
			</div>
		</div>
	)
}
